import { Minimize2, Maximize2 } from "lucide-react";
import { useCompactMoney } from "@/lib/useCompactMoney";

// Shared toggle button that flips the global compact-money preference.
// Drops straight into any PageHeader `actions` slot.
export default function CompactMoneyToggle({ className = "", testid = "compact-money-toggle" }) {
  const { compact, toggle } = useCompactMoney();
  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={compact}
      data-testid={testid}
      title={compact ? "Show full amounts" : "Show compact amounts ($246.3K)"}
      className={`text-xs px-3 py-2 border flex items-center gap-1.5 hover:bg-[var(--ll-mint)] transition-colors ${className}`}
      style={{ borderColor: "var(--ll-border)", background: compact ? "var(--ll-mint)" : "transparent" }}
    >
      {compact ? <Maximize2 size={13} /> : <Minimize2 size={13} />}
      <span className="hidden sm:inline">{compact ? "Full amounts" : "Compact"}</span>
    </button>
  );
}
